import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { HowTo } from './HowTo.types';

export function useHowToData(): Page<HowTo>['templateFields'] {
  return useCurrentPage<Page<HowTo>>().templateFields;
}
